var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-scale-transition',[_c('v-btn',{attrs:{"id":"btn-whatsapp","fab":"","dark":"","fixed":"","right":"","bottom":"","color":"success","href":"https://wa.me/5491131008698","target":"_blank"}},[_c('v-icon',[_vm._v("mdi-whatsapp")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }